import _ from "lodash";
import { useRecoilValue } from "recoil";

import { useGetExcludedEvaluationIdsQuery } from "graphql/generated";
import graphQLClient from "graphql/react-query";
import { useCheckPatientLogIn } from "src/hooks";
import { platformState } from "src/states";

export const useFetchExcludedEvalIds = (initExcludeEvalIds?: string[]) => {
  const { isGuest } = useCheckPatientLogIn();
  const platform = useRecoilValue(platformState);
  const { isLoading: loading, data } = useGetExcludedEvaluationIdsQuery(
    graphQLClient,
    {
      input: {
        platform
      }
    },
    {
      enabled: _.isEmpty(initExcludeEvalIds) && !isGuest
    }
  );

  return { loading, excludedEvalIds: data?.getExcludedEvaluationIds || initExcludeEvalIds || [] };
};
